import { WalkmeSdkService } from '../../infrastructure/WalkmeSdkProvider/types';

let dataRef: ReturnType<WalkmeSdkService['authorize']>;
let firstInit = true;

export const authorization = async (walkmeSdkService: WalkmeSdkService) => {
    if (!firstInit) {
        return walkmeSdkService.authorize();
    }

    if (dataRef) {
        return dataRef;
    }

    dataRef = walkmeSdkService.authorize();
    dataRef.then(() => (firstInit = false)).catch(() => {});

    return dataRef;
};
